import { render, staticRenderFns } from "./ComissaoConfiguracao.vue?vue&type=template&id=4966140f&scoped=true"
import script from "./ComissaoConfiguracao.vue?vue&type=script&lang=js"
export * from "./ComissaoConfiguracao.vue?vue&type=script&lang=js"
import style0 from "./ComissaoConfiguracao.vue?vue&type=style&index=0&id=4966140f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4966140f",
  null
  
)

export default component.exports